import React, { Component } from 'react';
import { Button } from 'b3';
import { Observable } from 'rxjs';
import './shortcut-button.less';
import { Motion, spring } from 'react-motion';

var ignoreTags = ['INPUT', 'SELECT', 'TEXTAREA'];

export default class ShortcutButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scale: 1
        };
    }
    componentDidMount() {
        var keydown$ = Observable.fromEvent(document, 'keydown')
            .filter(e => ! e.target.isContentEditable)
            .filter(e => ! ignoreTags.includes(e.target.tagName))
            .filter(e => {
                var hasTextSelection = !window.getSelection().isCollapsed;

                return ! hasTextSelection
            });

        var scale = this.props.growTo ? this.props.growTo : 1.3;

        this.keySubscription = keydown$.subscribe(e => {
            if(this.props.shortcut == e.key) {
                this.setState({scale});
                setTimeout(() => {
                    this.props.onClick(e);
                }, 300);
            }
        });
    }
    componentWillUnmount() {
        this.keySubscription.unsubscribe();
    }
    render() {
        var shortcutButtonStyles = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 15,
        };

        var style = {...this.props.style, ...shortcutButtonStyles};

        var props = {...this.props, style};
        
        var { scale } = this.state;

        return (
            <Motion defaultStyle={{scale: 1}} style={{scale: spring(scale)}}>
            {({scale}) => {
                var scaledStyle = {...props.style, transform: `scale(${scale})`};

                var finalProps = {...props, style: scaledStyle};
                return (
                    <Button {...finalProps}>
                        {this.props.children}
                        <div className="shortcut-hint-wrapper">
                            <div className="shortcut-hint-key">
                                {this.props.shortcut}
                            </div>
                        </div>        
                    </Button>
                );
            }}
            </Motion>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/shortcut-button/ShortcutButton.js